<div class="fade-in">
    <div class="content-section">
        <div class="section-header">
        <h2>Chart of Accounts</h2>
        <button class="primary-btn" (click)="openModal()">+ New Account</button>
        </div>

        <div class="table-container">
        <table class="ledger-table">
            <thead>
            <tr>
                <th style="width: 80px">Code</th>
                <th>Account Name</th>
                <th>Category</th>
                <th class="text-center">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let acc of accounts$ | async">
                <td class="font-mono" style="font-weight:700">{{ acc.code }}</td>
                <td style="font-weight:500">{{ acc.name }}</td>
                <td><span class="account-tag">{{ acc.category }}</span></td>
                <td class="text-center">
                  <button class="icon-btn" (click)="editAccount(acc)" [disabled]="deletingId === acc.id" title="Edit" style="border:none; background:none; cursor:pointer; margin-right: 8px;" [style.opacity]="deletingId === acc.id ? 0.5 : 1">✏️</button>
                  <button class="icon-btn" (click)="deleteAccount(acc.id)" [disabled]="deletingId === acc.id" title="Delete" style="border:none; background:none; cursor:pointer;">
                    <span *ngIf="deletingId !== acc.id">🗑️</span>
                    <span *ngIf="deletingId === acc.id">⏳</span>
                  </button>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ editingId ? 'Edit' : 'New' }} Account</h3>
      <button class="close-btn" (click)="closeModal()">×</button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Account Code</label>
        <input [(ngModel)]="newAccount.code" placeholder="e.g. 1010" [class.error]="(isSubmitted && !newAccount.code) || duplicateError" (input)="duplicateError = false">
        <div *ngIf="duplicateError" style="color: #ef4444; font-size: 0.8rem; margin-top: 4px;">
          This Account Code already exists.
        </div>
      </div>
      <div class="form-group">
        <label>Account Name</label>
        <input [(ngModel)]="newAccount.name" placeholder="e.g. Cash" [class.error]="isSubmitted && !newAccount.name">
      </div>
      <div class="form-group">
        <label>Category</label>
        <select [(ngModel)]="newAccount.category">
          <option value="Asset">Asset</option>
          <option value="Liability">Liability</option>
          <option value="Equity">Equity</option>
          <option value="Revenue">Revenue</option>
          <option value="Expense">Expense</option>
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button class="secondary-btn" (click)="closeModal()">Cancel</button>
      <button class="primary-btn" (click)="saveAccount()">Save</button>
    </div>
  </div>
</div>